import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class WelcomeContinueService {
  private titleTextSubject = new BehaviorSubject('');
  titleText = this.titleTextSubject.asObservable();

  nextPath = '';

  constructor() {}

  setTitleText(v: string) {
    setTimeout(() => {
      this.titleTextSubject.next(v);
    });
  }
}
